import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const FocusOnIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <circle cx="6.66647" cy="7.00192" r="3.97653" stroke={strokeColor} />
      <circle cx="6.66654" cy="6.99808" r="1.02347" stroke={strokeColor} />
      <path
        d="M6.6665 1L6.6665 4.04695"
        stroke={strokeColor}
        strokeLinecap="round"
      />
      <path
        d="M6.6665 9.95312L6.6665 13.0001"
        stroke={strokeColor}
        strokeLinecap="round"
      />
      <path
        d="M12.6665 7L9.61956 7"
        stroke={strokeColor}
        strokeLinecap="round"
      />
      <path
        d="M3.71338 7L0.666433 7"
        stroke={strokeColor}
        strokeLinecap="round"
      />
    </g>
  );
};

export const FocusOnIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <FocusOnIconGroup {...props} />
    </svg>
  );
};
